import BaseService from "./BaseService";
import { PersonRequest, PersonResponse, PersonsResponse } from "./mappers/PersonMapper";
import store from "@/store";

class PersonService extends BaseService {
  constructor() {
    super();
  }

  createPerson(data) {
    return this.post(`persons/`, PersonRequest(data))
      .then((response) => response.data)
      .then((data) => PersonResponse(data));
  }

  createCompanyPerson(id, data) {
    store.dispatch("app/setPersons", null);
    return this.post(`companies/${id}/persons/`, PersonRequest(data))
      .then((response) => response.data)
      .then((data) => PersonResponse(data));
  }

  getPersonsByCompany(id, onlyUsers = 1) {
    let modifiedData;

    if(onlyUsers && (store.getters["app/persons"] != null))
    {
      return Promise.resolve(store.getters["app/persons"]);
    }

    if(onlyUsers)
    {
      return this.get(`companies/${id}/persons/?has_user=1`)
      .then((response) => response.data)
      .then((data) => {
        modifiedData = PersonsResponse(data);
        store.dispatch("app/setPersons", modifiedData);
        return modifiedData;
      })
      .then(() => modifiedData);
    }
    else {
      return this.get(`companies/${id}/persons/`)
      .then((response) => response.data)
      .then((data) => PersonsResponse(data));
    }
  }

  getPersonsByCompanyAndHasUser(id) {
    return this.get(`companies/${id}/persons/?has_user=1`)
      .then((response) => response.data)
      .then((data) => PersonsResponse(data));
  }

  getPerson(id) {
    return this.get(`persons/${id}/`)
      .then((response) => response.data)
      .then((data) => PersonResponse(data));
  }

  getMyProfilePerson() {
    return this.get("my/profileperson/")
      .then((response) => response.data)
      .then((data) => PersonResponse(data));
  }

  updatePerson(id, data) {
    store.dispatch("app/setPersons", null);
    return this.patch(`persons/${id}/`, PersonRequest(data))
      .then((response) => response.data)
      .then((data) => PersonResponse(data));
  }

  deletePerson(id) {
    store.dispatch("app/setPersons", null);
    return this.delete(`persons/${id}/`);
  }
}

export default new PersonService();
